import React, { useEffect } from "react";
import { compose } from "redux";
// eslint-disable-next-line import/no-unresolved
import { Box, CreateRule } from "@ui-kit/components/index.es";
import * as checksMidleware from "middleware/checks";
import Head from "pages/_components/Head";
import Notification from "pages/_components/Notification";
import { arrayOf, bool, func, number, shape, string } from "prop-types";
import { connect } from "react-redux";
import { resizableRoute } from "pages/_components/Resizable";
import { push } from "react-router-redux";
import { actions as echeqRuleActions, selectors as echeqRuleSelectors } from "reducers/echeqRule";
import { selectors } from "reducers/echeqRules";
import {
    actions as frequentDestinationActions,
    selectors as frequentDestinationSelectors,
} from "reducers/frequentDestination";
import * as configUtils from "util/config";
import * as i18n from "util/i18n";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";

const ID_FORM = "manage.echeq.rules.create";
const ACTIONS_WOUT_ACCOUNT = ["ADMIT", "PAY"];
const CreateEcheqRule = (props) => {
    const {
        dispatch,
        accountList,
        daysBeforeList,
        actionsList,
        conditionsList,
        subConditionsIssuerList,
        subConditionsAmountList,
        subConditionsReceivedList,
        idEnvironment,
        listFrequentDestinations,
        initialValues,
        fetching,
        isDesktop,
        actionType,
        summarySelectedRule: { selectedRule, action },
        embeddedInV3Shell,
    } = props;

    useEffect(() => {
        if (
            !fetching &&
            (conditionsList?.length === 0 ||
                subConditionsIssuerList?.length === 0 ||
                subConditionsAmountList?.length === 0 ||
                subConditionsReceivedList?.length === 0)
        ) {
            dispatch(echeqRuleActions.echeqRulePreRequest());
        }

        if (!actionType) {
            dispatch(push("/v2/echeqRules"));
        }

        dispatch(frequentDestinationActions.loadListRequest(idEnvironment, null));
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["echeqRules"],
            titleKey: actionType ? `manage.echeq.rules.${actionType}.title` : "echeqs.rule.list.title",
            goBackPath: "/v2/echeqRules",
        });
        return () => {
            if (embeddedInV3Shell) {
                clearEmbeddedV3ShellLayoutState(dispatch);
            }
        };
    }, [dispatch, embeddedInV3Shell, isDesktop, actionType]);
    const extendedAmountEnabled = configUtils.getBoolean("increase.size.amount.link.iso8583", false);
    const payDiscountEnabled = configUtils.getBoolean("frontend.show.echeqRules.payDiscount.functionalities", false);

    const getFormLabel = (id) => {
        const formLabels = {
            name: i18n.get(`${ID_FORM}.label.name`),
            "name.placeholder": i18n.get(`${ID_FORM}.label.name.placeholder`),
            action: i18n.get(`${ID_FORM}.label.action`),
            "action.placeholder": i18n.get(`${ID_FORM}.label.action.placeholder`),
            account: i18n.get(`${ID_FORM}.label.account`),
            "account.placeholder": i18n.get(`${ID_FORM}.label.account.placeholder`),
            continue: i18n.get(`${ID_FORM}.label.continue`),
            addCondition: i18n.get(`${ID_FORM}.label.addCondition`),
            rmCondition: i18n.get(`${ID_FORM}.label.rmCondition`),
            condition: i18n.get(`${ID_FORM}.label.condition`),
            subcondition: i18n.get(`${ID_FORM}.label.subcondition`),
            "condition.placeholder": i18n.get(`${ID_FORM}.label.condition.placeholder`),
            "subcondition.issuer.placeholder": i18n.get(`${ID_FORM}.label.subcondition.issuer.placeholder`),
            "subcondition.amount.placeholder": i18n.get(`${ID_FORM}.label.subcondition.amount.placeholder`),
            "subcondition.days.placeholder": i18n.get(`${ID_FORM}.label.subcondition.days.placeholder`),
            "subcondition.received_by.placeholder": i18n.get(`${ID_FORM}.label.subcondition.received_by.placeholder`),
            amount: i18n.get(`${ID_FORM}.label.amount`),
            "amount.from": i18n.get("echeqs.amountFrom.label"),
            "amount.to": i18n.get("echeqs.amountTo.label"),
            reference: i18n.get(`${ID_FORM}.label.reference`),
            "reference.placeholder": i18n.get(`${ID_FORM}.label.reference.placeholder`),
            includesAdmission: i18n.get(`${ID_FORM}.label.includesAdmission`),
            beneficiary: i18n.get(`${ID_FORM}.label.beneficiary`),
            endorseType: i18n.get(`${ID_FORM}.label.endorseType`),
            address: i18n.get(`${ID_FORM}.label.address`),
            referenceValue: i18n.get(`${ID_FORM}.label.referenceValue`),
        };
        return formLabels[id];
    };

    const handleBack = () => dispatch(push("/v2/echeqRules"));

    const contactsArray = Array.from(
        new Map(
            listFrequentDestinations?.map((contact) => [
                contact.recipientDocumentNumber, // clave para evitar duplicados
                {
                    name: contact.recipientName,
                    document: contact.recipientDocumentNumber,
                    documentType: "CUIT / CUIL / CDI",
                },
            ]),
        ).values(),
    );

    const handleAccountSearch = async (cuilCuitOrCdi) =>
        new Promise((resolve, reject) => {
            checksMidleware
                .bankedBeneficiary({ document: cuilCuitOrCdi, type: "CUIT" })
                .then(async ({ data: { data }, type }) => {
                    if (type === "W") {
                        if (JSON.parse(data.errorFormat)) {
                            throw new Error();
                        } else {
                            reject(i18n.get("agenda.create.account.error.exist"));
                        }
                    }
                    // eslint-disable-next-line camelcase
                    const { beneficiario_documento, beneficiario_razon_social } = data?.beneficiary;

                    resolve({
                        // eslint-disable-next-line camelcase
                        name: beneficiario_razon_social,
                        // eslint-disable-next-line camelcase
                        document: beneficiario_documento,
                        documentType: "CUIT / CUIL / CDI",
                    });
                })
                .catch(() => {
                    reject(i18n.get("manage.echeq.rules.person.error.notFound"));
                });
        });

    return (
        <>
            {!embeddedInV3Shell && (
                <Notification scopeToShow="echeqRules" notificationClassname={!isDesktop ? "z-index-9" : ""} />
            )}
            {(!embeddedInV3Shell || isDesktop) && (
                <Box className="admin-detail-head" px={48}>
                    {isDesktop ? (
                        <>
                            <Head onBack={handleBack} />
                            <Head title={`manage.echeq.rules.${actionType}.title`} />
                        </>
                    ) : (
                        <Head
                            onBack={!isDesktop ? handleBack : null}
                            title={`manage.echeq.rules.${actionType}.title`}
                            titleClassName={!isDesktop ? "header-mobile-title-background-blue overflow-visible" : ""}
                            headerClassName={!isDesktop ? "blue-main-header-mobile" : ""}
                            hideNavbarInMobile
                        />
                    )}
                </Box>
            )}
            <CreateRule
                accountsOptions={accountList}
                actionsOptions={actionsList}
                conditionsOptions={conditionsList}
                contactsArray={contactsArray}
                daysOptions={daysBeforeList}
                getFormLabel={getFormLabel}
                initialValues={initialValues}
                onSubmit={(valuesForm) => {
                    let finalCurrency = valuesForm?.currency;
                    if (ACTIONS_WOUT_ACCOUNT.includes(valuesForm.action?.value)) {
                        const hasAmountCondition = valuesForm.conditions?.some((c) => c.type === "AMOUNT");
                        if (!hasAmountCondition) {
                            finalCurrency = null;
                        }
                    }
                    dispatch(
                        echeqRuleActions.echeqRulePreviewRequest({
                            ...valuesForm,
                            currency: finalCurrency,
                            numberRule: selectedRule?.idRule,
                            actionType: action,
                        }),
                    );
                }}
                operatorAmountOptions={subConditionsAmountList}
                operatorIssuerOptions={subConditionsIssuerList}
                operatorReceivedOptions={subConditionsReceivedList}
                searchCallback={handleAccountSearch}
                loading={fetching}
                actionsText={configUtils.get("frontend.echeqRule.NewRule.Tooltip")}
                contactListText={configUtils.get("frontend.echeqRule.NewRule.contactListText.Tooltip")}
                amountMaxLength={extendedAmountEnabled ? 15 : 10}
                disableOnNoChanges={actionType === "modify"}
                enableUSD
                enableSelectAll={configUtils.getBoolean(
                    "frontend.show.echeqRules.contactsMassiveSelection.functionalities",
                    false,
                )}
                enablePayAction={payDiscountEnabled}
                actionPayText={i18n.get("manage.echeq.rules.create.pay.tooltip")}
                enableDiscountAction={payDiscountEnabled}
                actionDiscountText={i18n.get("manage.echeq.rules.create.discount.tooltip")}
                includesAdmissionTooltip={configUtils.get("frontend.echeqRules.admitSwitch.tooltip")}
                enableChargeIncludesAdmissionCheckbox={payDiscountEnabled}
                actionChargeText={i18n.get("manage.echeq.rules.create.charge.tooltip")}
                actionAdmitText={i18n.get("manage.echeq.rules.create.admit.tooltip")}
            />
        </>
    );
};

CreateEcheqRule.propTypes = {
    dispatch: func.isRequired,
    accountList: arrayOf(shape({})).isRequired,
    daysBeforeList: arrayOf(shape({})).isRequired,
    actionsList: arrayOf(shape({})).isRequired,
    conditionsList: arrayOf(shape({})).isRequired,
    subConditionsIssuerList: arrayOf(shape({})).isRequired,
    subConditionsAmountList: arrayOf(shape({})).isRequired,
    subConditionsReceivedList: arrayOf(shape({})).isRequired,
    listFrequentDestinations: shape({}).isRequired,
    idEnvironment: number.isRequired,
    initialValues: shape({}).isRequired,
    fetching: bool.isRequired,
    isDesktop: bool.isRequired,
    summarySelectedRule: shape({}),
    actionType: string,
    embeddedInV3Shell: bool,
};
CreateEcheqRule.defaultProps = {
    summarySelectedRule: {
        pageNumber: null,
        totalPages: null,
    },
    actionType: null,
    embeddedInV3Shell: false,
};

const mapStateToProps = (state) => ({
    fetching: echeqRuleSelectors.getFetching(state),
    accountList: echeqRuleSelectors.getAccountList(state),
    daysBeforeList: echeqRuleSelectors.getDaysBeforeList(state),
    actionsList: echeqRuleSelectors.getActionsList(state),
    conditionsList: echeqRuleSelectors.getConditionsList(state),
    subConditionsIssuerList: echeqRuleSelectors.getSubConditionsIssuerList(state),
    subConditionsAmountList: echeqRuleSelectors.getSubConditionsAmountList(state),
    subConditionsReceivedList: echeqRuleSelectors.getSubConditionsReceivedList(state),
    fetchingFrequentDestinations: frequentDestinationSelectors.getFetching(state),
    idEnvironment: frequentDestinationSelectors.getEnviromentId(state),
    listFrequentDestinations: frequentDestinationSelectors.getListFrequentDestinations(state),
    initialValues: echeqRuleSelectors.getInitialValues(state),
    summarySelectedRule: selectors.getSummarySelectedRule(state),
    actionType: echeqRuleSelectors.getActionType(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(CreateEcheqRule);
